// extracted by mini-css-extract-plugin
module.exports = {"container":"founders_container__GvzrJ"};